import { BarChart3 } from "lucide-react";
import { SG7TacticalPanel } from "./sg7";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface StatisticalSuggestionsCardProps {
  suggestions: string[];
  className?: string;
}

export function StatisticalSuggestionsCard({ suggestions, className }: StatisticalSuggestionsCardProps) {
  const { t } = useTranslation('analysis');

  if (!suggestions || suggestions.length === 0) return null;

  return (
    <SG7TacticalPanel className={className}>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="p-1.5 rounded-lg bg-[hsl(var(--sg7-surface-2))]">
            <BarChart3 className="h-5 w-5 text-[hsl(var(--sg7-gold))]" />
          </div>
          <h3 className="text-base font-black text-[hsl(var(--sg7-gold))]">
            {t('cards.extraSuggestions')}
          </h3>
        </div>
        
        <ul className="space-y-2">
          {suggestions.map((suggestion, index) => (
            <li 
              key={index}
              className="flex items-start gap-2 text-sm"
            >
              <span className={cn(
                "flex-shrink-0 w-5 h-5 rounded-full",
                "border border-[hsl(var(--sg7-gold))]",
                "text-[hsl(var(--sg7-gold))]",
                "flex items-center justify-center text-xs font-bold"
              )}>
                {index + 1}
              </span>
              <span className="leading-relaxed text-[hsl(var(--sg7-text))]">{suggestion}</span>
            </li>
          ))}
        </ul>
      </div>
    </SG7TacticalPanel>
  );
}
